export const CHANGE_SEARCHFIELD = 'CHANGE_SEARCHFIELD';

export const REQUEST_USERS_PENDING = 'REQUEST_USERS_PENDING';
export const REQUEST_USERS_SUCCESS = 'REQUEST_USERS_SUCCESS';
export const REQUEST_USERS_FAILED = 'REQUEST_USERS_FAILED';